import { pilot } from '~/services/serviceInstances';

interface Request {
  files: File[];
}

interface AttachmentResponse {
  id: string;
  fileName: string;
  fileType: string;
}

type Response = AttachmentResponse[];

export const uploadAttachments = async (
  request: Request,
): Promise<Response> => {
  const { files } = request;

  const promises = files.map(async (file, index) => {
    const formData = new FormData();
    formData.append('file', file);
    return pilot.post('/attachment/', formData).then((response) => ({
      response,
      file,
      index,
    }));
  });

  const promisesResolved = promises.map((promise) => promise.catch(() => null));

  const results = await pilot.concurrentRequests(promisesResolved);

  return results
    .filter((result) => result !== null)
    .map((result) => ({
      id: (result.response as any).id,
      fileName: (result.response as any).fileName.split('.')[0],
      fileType: '.' + (result.response as any).fileName.split('.').pop(),
    }));
};
